module.exports = __webpack_public_path__ + "static/media/sgd-16.fbbd5949.png";